import { DialogService, GridAction } from '@eforall/dashboard';
import { AIPromptAndResponseWithUpdatedUTC } from '@interfaces';
import { AdvisorPromptDialog } from '../../../../../../ui/widget';


export function getActions(dialog: DialogService) {

	const actions: GridAction<AIPromptAndResponseWithUpdatedUTC>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Prompt Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showCustom(AdvisorPromptDialog, { data: { aiPromptId: rows[0]!.aiPromptId } }, 900, 700);
			}
		}
	];

	return actions;
}
